$(document).ready(function () {
  setTimeout(function() {
    $(".complimentoryWrapper, .giftWrapperCheckBox").removeClass("hide");
  }, 1000);  
});

/* Adding Item and Properties with given variant ID */
async function addCartItems(items) {
  for (let item of items) {
    try {
      const addResponse = await $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: { quantity: item.quantity, id: item.variantId, properties: item.properties || {} },
        dataType: 'json'
      });
    } catch (error) {
      console.error(`Error adding item with variantId ${item.variantId}: `, error);
    }
  }
}

/* Updating Properties of the item with key */
async function updateCartItemProperties(items) {
  for (let item of items) {
    try {
      await $.post('/cart/change.js', {
        quantity: item.quantity || 0,
        id: item.key,
        properties: item.properties || {}
      });
    } catch (error) {
      console.error(`Error updating properties for item with key ${item.key}: `, error);
    }
  }
}

/* Managing Delays between functions because of Shopify API call limits */
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/* Removing Item from cart with key */
async function updateCartItems(items) {
  for (let item of items) {
    try {
      await $.post('/cart/change.js', { quantity: 0, id: item.key });
    } catch (error) {
      console.error(`Error removing item with key ${item.key}: `, error);
    }
  }
}

/* Handle the click event of gift wrap checkbox */
async function giftWrapCheckboxHandle(e) {
  $(".siteLoader").show();
  setTimeout(async function () {
    const parentWrapper = $(e).closest(".cartPageGiftWrapper");
    const variantId = parseInt(parentWrapper.attr("data-variantid"));
    const variantQnty = parseInt(parentWrapper.attr("data-quantity"));
    const sku = parentWrapper.attr("data-sku");
    const grabParentAssociateKey = $(e).attr("data-unique-key");
    const giftWrapVarId = parseInt($(e).attr("data-giftwrapvariantid"));
    const isChecked = $(e).is(":checked");
    const complimentaryCheckbox = parentWrapper.parent().find(".js-complimentary-wrapper");
    const complimentaryChecked = complimentaryCheckbox.find("input[type='checkbox']").is(":checked");
    const complimentaryKeyToRemove = complimentaryChecked ? complimentaryCheckbox.attr("data-line_itemkey") : null;

    if (isChecked) {
      complimentaryCheckbox.find("input[type='checkbox']").prop("checked", false);
      $("#complimentary_Note").addClass("hide");
    }

    try {
      // Step 1: Remove complimentary gift wrap (if applicable)
      if (complimentaryChecked && complimentaryKeyToRemove) {
        await updateCartItems([{ key: complimentaryKeyToRemove }]);
      }

      await delay(600); // Delay of 500 milliseconds (.5 second)

      // Step 2: Process gift wrap logic
      for (const data of cart.items) {
        const isMatchingVariant =
          variantId === parseInt(data.id) &&
          data.properties["_associated_unique_key"] === grabParentAssociateKey;

        if (isChecked) {
          if (isMatchingVariant) {
            var addGwiaKey = data.properties?._giftwrap
            const newProperties = {
              ...data.properties,
              _giftwrap: "true",
              ...(addGwiaKey !== 'true' && { _gwia: "true" }),
              _complimentory_wrap_selected: "no",
            };

            // Clean up any old properties
            delete newProperties._CompGiftNote;

            // Update properties first (without redundant add call)
            await updateCartItemProperties([{ key: data.key, quantity: data.quantity, properties: newProperties }]);
            
            await delay(600); // Delay of 600 milliseconds (.6 second)
            
            // Add the gift wrap product
            await addCartItems([{
              variantId: giftWrapVarId,
              quantity: variantQnty,
              properties: {
                sku,
                _associated_unique_key: grabParentAssociateKey,
                _associated_variant_id: variantId,
              }
            }]);
          }
        } else {
          if (
            parseInt(data.properties["_associated_variant_id"]) === variantId &&
            data.properties["_associated_unique_key"] === grabParentAssociateKey
          ) {
            // Remove the gift wrap product
            await updateCartItems([{ key: data.key }]);
          }
          
          await delay(600); // Delay of 600 milliseconds (.6 second)

          if (isMatchingVariant) {
            // Clear gift-related properties from the main product
            const newProperties = { ...data.properties };
            if (newProperties?._gwia === 'true') {
              delete newProperties._giftwrap;
              delete newProperties._gwia;
            }
            delete newProperties._complimentory_wrap_selected;
            delete newProperties._GiftWrapNote;
            delete newProperties._CompGiftNote;

            await updateCartItemProperties([{ key: data.key, quantity: data.quantity, properties: newProperties }]);
          }
        }
      }
    } catch (error) {
      console.error("Error handling gift wrap: ", error);
    } finally {
      await delay(100);
      window.location.reload();
    }
  }, 500);
}

/* Handle the click event of Complimentary Gift Box */
async function complimentoryCheckboxHandle(e) {
  $(".siteLoader").show();
  setTimeout(async function () {
    const isChecked = $(e).is(":checked");
    const parentWrapper = $(e).closest(".cartPageGiftWrapper");
    const variantId = parseInt(parentWrapper.attr("data-variantid"));
    const variantQnty = parseInt(parentWrapper.attr("data-quantity"));
    const sku = parentWrapper.attr("data-sku");
    const grabParentAssociateKey = $(e).attr("data-unique-key");
    const ComplimentaryVarId = parseInt($(e).attr("data-complimentaryVariantId"));
    const giftWrapCheckbox = parentWrapper.parent().find(".js-gift-wrap");
    const giftWrapKeyToRemove = giftWrapCheckbox.find("input[type='checkbox']").is(':checked') ? giftWrapCheckbox.attr("data-line_itemkey") : null;

    if (isChecked) {
      $("#complimentary_Note").removeClass("hide");
      $("#complimentarywrapTextarea" + variantId + grabParentAssociateKey).attr("data-required", true).val('');
      $("#complimentary-note-occasion" + variantId).find('#compnote-wrap-occasion').attr("data-required", true);
      $("#complimentary-note-lucky" + variantId).find('#compnote-wrap-lucky-recipient').attr("data-required", true);
      $(".complimentoryWrapper").find(".giftwrapcounter > span").text("0");
    } else {
      $("#complimentarywrapTextarea" + variantId + grabParentAssociateKey).removeAttr("data-required").val('');
      $("#complimentary-note-occasion" + variantId).find('#compnote-wrap-occasion').removeAttr("data-required");
      $("#complimentary-note-lucky" + variantId).find('#compnote-wrap-lucky-recipient').removeAttr("data-required");
      $(".complimentoryWrapper").find(".giftwrapcounter > span").text("0");
      $("#complimentary_Note").addClass("hide");
    }

    if (isChecked) {
      giftWrapCheckbox.find("input[type='checkbox']").prop('checked', false);
      $("#complimentary_Note").addClass("hide");
    }

    try {
      // Step 1: Remove gift wrap if checked
      if (giftWrapKeyToRemove) {
        await updateCartItems([{ key: giftWrapKeyToRemove }]);
      }

      await delay(600); // Delay of 600 milliseconds (.6 second)    

      // Step 2: Loop through cart items to handle the complimentary wrap
      for (const data of cart.items) {
        const isMatchingVariant = variantId === parseInt(data.id) && data.properties["_associated_unique_key"] === grabParentAssociateKey;

        if (isChecked) {
          if (isMatchingVariant) {
            const newProperties = {
              ...data.properties,
              _complimentory_wrap_selected: "yes"
            };
            delete newProperties._GiftWrapNote;
            if(data.properties?._gwia === 'true'){
              delete newProperties._gwia;
              delete newProperties._giftwrap;
            }

            await updateCartItemProperties([{ key: data.key, quantity: data.quantity, properties: newProperties }]);

            await delay(600); // Delay of 600 milliseconds (.6 second)

            await addCartItems([{
              variantId: ComplimentaryVarId,
              quantity: variantQnty,
              properties: { sku, _associated_unique_key: grabParentAssociateKey, _complimentary_associated_variant_id: variantId }
            }]);
          }
        } else {
          if (parseInt(data.properties['_complimentary_associated_variant_id']) === variantId && data.properties["_associated_unique_key"] === grabParentAssociateKey) {
            await updateCartItems([{ key: data.key }]);
          } else if (isMatchingVariant) {
            const newProperties = { ...data.properties };
            delete newProperties._GiftWrapNote;
            delete newProperties._CompGiftNote;
            // delete newProperties._giftwrap;
            newProperties._complimentory_wrap_selected = "no";
            
            await delay(600); // Delay of 600 milliseconds (.6 second)
            
            await updateCartItemProperties([{ key: data.key, quantity: data.quantity, properties: newProperties }]);
          }
        }
      }
    } catch (error) {
      console.error("Error handling complimentary wrap: ", error);
    } finally {
      await delay(100);
      window.location.reload();
    }
  }, 500);
}

/*** This function is updating the Gift Wrap Note ***/
function updateGiftWrapNote(e) {
  let dataQuantity = 1;
  var val = jQuery(e).val();
  var lineid = jQuery(e).attr("data-line-id");
  var dataTags = jQuery(e).attr("data-tag");
  var variantId = jQuery(e).attr("data-variantid");
  var giftWrapNote = jQuery(e).attr("data-giftWrapNote");
  var customlengthmsg = jQuery(e).attr("data-customlengthmsg");
  var _associated_unique_key = jQuery(e).attr("data-unique-key");
  dataQuantity = jQuery(e).attr("data-quantity");
  
  var giftWrapNoteDate = jQuery(e)
    .parents(`.js-vow-cart-page-main-parent`)
    .find(`#cart-giftwrap-wrap-occasion-date${variantId}${_associated_unique_key}`)
    .val();

  var giftWrapNoteUpdated = jQuery(e)
    .parents(`.js-vow-cart-page-main-parent`)
    .find(`#giftwrapTextarea${variantId}${_associated_unique_key}`)
    .val();

  if (!lineid || !_associated_unique_key) {
    console.error("Missing or invalid line ID or unique key.");
    return;
  }

  $(".siteLoader").show();
  fetch("/cart.js")
    .then(response => response.json())
    .then(cartData => {
      if (!cartData || !cartData.items || cartData.items.length === 0) {
        throw new Error("Empty cart.");
      }

      let props = {};
      cartData.items.forEach(item => {
        if (item.properties && item.id === parseInt(lineid) && item.properties["_associated_unique_key"] === _associated_unique_key) {
          props = item.properties;
        }
      });

      if (customlengthmsg) props.Custom_Length_Note = customlengthmsg;
      if (giftWrapNote) props._GiftWrapNote = giftWrapNote;

      if (dataTags) {
        var noteKey = dataTags === "custom-length" ? "Custom_Length_Note" : "_GiftWrapNote";
        props[noteKey] = giftWrapNoteUpdated;
      }

      return { id: lineid, quantity: dataQuantity, properties: props };
    })
    .then(dataToSend => {
      return fetch('/cart/change.js', {
        body: JSON.stringify(dataToSend),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      });
    })
    .then(response => response.json())
    .then(cart => {
      $(".siteLoader").hide();
      setTimeout(() => location.reload(), 300);
    })
    .catch(error => {
      $(".siteLoader").hide();
      console.error("Error:", error);
    });
}

/*** This function is updating the complimentary Wrap Note ***/
function updatecomplimentaryWrapNote(e) {
  let dataQuantity = 1;
  var lineid = jQuery(e).attr("data-line-id");
  var dataTags = jQuery(e).attr("data-tag");
  var variantId = jQuery(e).attr("data-variantid");
  var _associated_unique_key = jQuery(e).attr("data-unique-key");
  var complimentaryNoteUpdated = jQuery(e).parents(`.js-vow-cart-page-main-parent`).find(`#complimentarywrapTextarea${variantId}${_associated_unique_key}`).val();
  var complimentaryNote = jQuery(e).attr("data-complimentoryWrapNote");
  var customlengthmsg = jQuery(e).attr("data-customlengthmsg");
  dataQuantity = jQuery(e).attr("data-quantity");

  if (!complimentaryNoteUpdated || !complimentaryNoteUpdated.length) {
    jQuery('.Cart__Checkout').attr('disabled', 'disabled');
    jQuery(`#complimentarywrapTextarea${variantId}${_associated_unique_key}`).addClass('required');
    return;
  } else {
    jQuery(`#complimentarywrapTextarea${variantId}${_associated_unique_key}`).removeClass('required');
  }

  if (!lineid || !_associated_unique_key) {
    console.error("Missing or invalid line ID or unique key.");
    return;
  }

  $(".siteLoader").show();
  fetch("/cart.js")
    .then(response => response.json())
    .then(cartData => {
      if (!cartData || !cartData.items || cartData.items.length === 0) {
        throw new Error("Empty cart.");
      }

      var item = cartData.items.find(item => item.id === parseInt(lineid) && item.properties["_associated_unique_key"] === _associated_unique_key);
      let props = item ? item.properties : {};

      if (customlengthmsg) props.Custom_Length_Note = customlengthmsg;
      if (complimentaryNote) props._CompGiftNote = complimentaryNote;

      if (dataTags) {
        var noteKey = dataTags === "custom-length" ? "Custom_Length_Note" : "_CompGiftNote";
        props[noteKey] = complimentaryNoteUpdated;
      }

      return { id: lineid, quantity: dataQuantity, properties: props };
    })
    .then(dataToSend => {
      return fetch('/cart/change.js', {
        body: JSON.stringify(dataToSend),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      });
    })
    .then(response => response.json())
    .then(cart => {
      $(".siteLoader").hide();
      setTimeout(() => location.reload(), 300);
    })
    .catch(error => {
      $(".siteLoader").hide();
      console.error("Error:", error);
    });
}